import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import {
  BackgroundColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      pointerEvents: 'none',
    },
    corner: {
      position: 'absolute',
      top: Spacings.s2,
      right: Spacings.s2,
    },
    inline: {
      marginLeft: Spacings.s6,
    },
    dot: {
      width: Spacings.s12,
      height: Spacings.s12,
      borderRadius: CornerRadius.circle,
      backgroundColor: PrimaryColors.base.default,
      border: [2, 'solid', BackgroundColors.base],
    },
  },
  { name: 'GenerationStatusBadge' }
);

export default useStyles;
